const POLICY_TYPE_SUFFIXES = [
	'terms-of-use',
	'privacy-policy',
	'data-processing',
	'third-party-sharing',
	'marketing',
];

export function formatPolicyVersion(version: string): string {
	for (const suffix of POLICY_TYPE_SUFFIXES) {
		if (version.endsWith(`-${suffix}`)) {
			return version.slice(0, -(suffix.length + 1));
		}
	}
	return version;
}
